import { render, staticRenderFns } from "./WhatsAppDeliveryMode.vue?vue&type=template&id=9193fbf6&scoped=true"
import script from "./WhatsAppDeliveryMode.vue?vue&type=script&lang=js"
export * from "./WhatsAppDeliveryMode.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppDeliveryMode.vue?vue&type=style&index=0&id=9193fbf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9193fbf6",
  null
  
)

export default component.exports